import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import fpq from '@/components/fpqmodel'
import jlb from '@/components/jlbmodel'
import pcmt from '@/components/pcmtmodel'
import zlb from '@/components/zlbmodel'
import cmxc from '@/components/cmxcmodel'
import jthhq from '@/components/jthhqmodel'
import bshwq from "@/components/bshwq";
import szhwq from "@/components/szhwq";
import bgxkskkzz from "@/components/bgxkskkzz";
import scbyfpq from "@/components/scbyfpq";
import kcf from "@/components/kcf";
import zhxkfpq from "@/components/zhxkfpq";
import lgskskkzz from "@/components/lgskskkzz";
import mtndjg from "@/components/mtndjg";
import newmodel from "@/components/newmodel";
import tbd from "@/components/tbdmodel";
import login from '@/components/login'
import test from "@/components/test";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      redirect: "login"
    },
    {
      path: "/fpq",
      name: "fpq",
      component: fpq
    },
    {
      path: "/jlb",
      name: "jlb",
      component: jlb
    },
    {
      path: "/pcmt",
      name: "pcmt",
      component: pcmt
    },
    {
      path: "/zlb",
      name: "zlb",
      component: zlb
    },
    {
      path: "/cmxc",
      name: "cmxc",
      component: cmxc
    },
    {
      path: "/jthhq",
      name: "jthhq",
      component: jthhq
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/tbd",
      name: "tbd",
      component: tbd
    },
    {
      path: "/bshwq",
      name: "bshwq",
      component: bshwq
    },
    {
      path: "/szhwq",
      name: "szhwq",
      component: szhwq
    },
    {
      path: "/bgxkskkzz",
      name: "bgxkskkzz",
      component: bgxkskkzz
    },
    {
      path: "/scbyfpq",
      name: "scbyfpq",
      component: scbyfpq
    },
    {
      path: "/kcf",
      name: "kcf",
      component: kcf
    },
    {
      path: "/zhxkfpq",
      name: "zhxkfpq",
      component: zhxkfpq
    },
    {
      path: "/lgskskkzz",
      name: "lgskskkzz",
      component: lgskskkzz
    },
    {
      path: "/mtndjg",
      name: "mtndjg",
      component: mtndjg
    },
    {
      path: "/newmodel",
      name: "newmodel",
      component: newmodel
    },
    {
      path: "/test",
      name: "test",
      component: test
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js